import { Component, Injectable, OnInit } from '@angular/core';
import { MapService } from 'src/app/services/map.service';
import olMap from 'ol/Map';
import { Chart } from 'chart.js';
import { ProcedurePerformanceLine } from 'src/app/models/procedure-performance-line';
import { CalculationsService } from 'src/app/services/calculations.service';
import { PointsService } from 'src/app/services/points.service';
import * as fileSaver from 'file-saver';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { TabsService } from 'src/app/services/tabsService';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { copyBlobToClipboard } from 'copy-image-clipboard'

@Component({
  selector: 'app-calculation-procedures',
  templateUrl: './calculation-procedures.component.html',
  styleUrls: ['./calculation-procedures.component.scss'],
  standalone: false
})
@Injectable({
  providedIn: 'root',
})
export class CalculationProceduresComponent implements OnInit {
  //navaids tabs control
  firstTabActive: boolean = true;
  loading: boolean = false;
  map: olMap;




  constructor(
    public calculationsService: CalculationsService,
    private mapService: MapService,
    private pointsService: PointsService,
    private modalService: ModalControlService,
    public menuController : MenuManagementService,
    public tabsService: TabsService
  ) {
    this.map = this.mapService.getMap('map');
  }

  ngOnInit(): void {}

  cancel(): void {
    this.calculationsService.procedureAnalysisResultActive = false;
    this.calculationsService.procedurePerformanceLines = [];
    // remove features from map
    this.pointsService.procedureGraphLayer.childLayers?.forEach(el => {
      el.layers.forEach(layer => {
        layer.olLayer.getSource().clear();
      })
    });
  }


  exportToCsv() {
    var fileName = "ExportedPerformanceAnalysis_" + new Date().toISOString().slice(0, 19) + ".csv";
    var rows = <any>this.calculationsService.redundancyPercentage ;
    if (!rows ) {
      return;
    }
    const separator = ';';
    var keys = ["Type",
    "Center Value",
    "Full Width"];
    let table1 =
      keys.join(separator) + separator +
      '\n' +
      rows.map(row => {
        let valuesToMap =  [row.conditions[0], row.conditions[1]];
        return row.type + separator + valuesToMap.map(k => {
          let cell = k === null || k === undefined ? '' : k;
          return cell + "%";
        }).join(separator) + separator;
      }).join('\n');

    rows = <any>this.calculationsService.redundancyPercentageTable2 ;

    keys = ["Type",
    "Worst Value",
    "Worst Value + Receiver Delay"];
    let table2 =
      keys.join(separator) + separator +
      '\n' +
      rows.map(row => {
        let valuesToMap =  [row.conditions[0], row.conditions[1]];
        return row.type + separator + valuesToMap.map(k => {
          let cell = k === null || k === undefined ? '' : k;
          return cell + "%";
        }).join(separator) + separator;
      }).join('\n');


    const blob = new Blob([table1 + "\n\n" + table2], { type: 'text/csv;charset=utf-8;' });
    fileSaver.saveAs(blob, fileName);
  }

  getCanvasUrl(canvasName : string) : void {
    if (this.loading) {
      return;
    }

    let canvas : HTMLCanvasElement = document.getElementById(canvasName) as HTMLCanvasElement;
    canvas.focus();
    this.copyToClipboard(canvas.toDataURL());
  }

  async copyToClipboard( url : string ) {
    this.loading = true;
    try {
      const data = await fetch(url);
      const blob = await data.blob();
      await copyBlobToClipboard(blob);
    } catch (error) {
      console.error('Copy image to clipboard failed.', error);

      if (error && (error as DOMException).name === 'NotAllowedError') {
        this.modalService.showMesssageModal(
          'Warning',
          'Copy to clipboard was interrupted. Please keep this tab active until the copy process finishes, then try again.'
        );
      } else {
        this.modalService.showMesssageModal(
          'Warning',
          'Unable to copy to clipboard. Please try again.'
        );
      }
    } finally {
      this.loading = false;
    }
  }
}
